module.exports = __webpack_public_path__ + "img/logo3.9920d126.png";